(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-carousel-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class SplitSectionProduct {
    constructor(element) {
      this.element = element;
      this.container = element.querySelector('.split-section__product-container');
      if (!this.container) return;
      
      this.items = Array.from(element.querySelectorAll('.split-section__product-item'));
      this.indicators = Array.from(element.querySelectorAll('.split-section__indicator'));
      
      this.currentIndex = 0;
      this.sectionId = this.container.dataset.sectionId;
      this.hoverIntensity = parseInt(this.container.dataset.hoverIntensity) || 14;
      this.hoverSpeed = parseFloat(this.container.dataset.hoverSpeed) || 3;
      this.autoHover = this.container.dataset.autoHover === 'true';
      this.hoverInterval = parseInt(this.container.dataset.hoverInterval) || 3000;
      this.imagesCount = parseInt(this.container.dataset.imagesCount) || 0;
      this.intervalId = null;
      this.isHovering = false;
      this.isVisible = true;
      this.isDestroyed = false;
      
      console.log('SplitSectionProduct initialized:', {
        imagesCount: this.imagesCount,
        itemsLength: this.items.length,
        indicatorsLength: this.indicators.length,
        autoHover: this.autoHover
      });
      
      this.init();
    }
    
    init() {
      if (this.items.length <= 1) {
        console.log('Not enough images for switching functionality');
        return;
      }
      
      this.setupItems();
      this.bindEvents();
      this.setupIntersectionObserver();
      
      // Set CSS variables
      this.element.style.setProperty('--hover-intensity', `${this.hoverIntensity}px`);
      this.element.style.setProperty('--hover-speed', `${this.hoverSpeed}s`);
      
      if (this.autoHover) {
        console.log('Starting auto hover with interval:', this.hoverInterval);
        this.startAutoHover();
      }
    }
    
    setupItems() {
      this.items.forEach((item, index) => {
        const isActive = index === 0;
        
        if (isActive) {
          item.classList.add('active');
          item.style.opacity = '1';
          item.style.transform = 'scale(1)';
          item.setAttribute('aria-hidden', 'false');
        } else {
          item.classList.remove('active');
          item.style.opacity = '0';
          item.style.transform = 'scale(0.95)';
          item.setAttribute('aria-hidden', 'true');
        }
      });
    }
    
    setupIntersectionObserver() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (!this.isVisible) {
              this.pauseAutoHover();
            } else if (this.autoHover && !this.isDestroyed) {
              this.resumeAutoHover();
            }
          });
        }, { threshold: 0.3 });
        
        this.observer.observe(this.element);
      }
    }
    
    bindEvents() {
      // Indicator clicks
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('Indicator clicked:', index);
          this.goToImage(index);
        });
        
        indicator.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            console.log('Indicator key pressed:', index);
            this.goToImage(index);
          }
        });
      });
      
      // Container hover events for manual switching
      if (this.items.length > 1) {
        this.container.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        this.container.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
        
        // Add click to cycle through images
        this.container.addEventListener('click', (e) => {
          if (!e.target.closest('.split-section__indicator') && !e.target.closest('a')) {
            this.nextImage();
          }
        });
      }
      
      // Auto-hover pause/resume
      if (this.autoHover) {
        this.container.addEventListener('focusin', () => this.pauseAutoHover());
        this.container.addEventListener('focusout', () => this.resumeAutoHover());
        
        // Visibility change
        this.visibilityHandler = () => {
          if (document.hidden) {
            this.pauseAutoHover();
          } else if (this.isVisible && !this.isDestroyed) {
            this.resumeAutoHover();
          }
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);
      }
    }
    
    handleMouseEnter() {
      this.isHovering = true;
      this.container.classList.add('hovering');
      if (this.autoHover) {
        this.pauseAutoHover();
      }
    }
    
    handleMouseLeave() {
      this.isHovering = false;
      this.container.classList.remove('hovering');
      if (this.autoHover && !this.isDestroyed) {
        this.resumeAutoHover();
      }
    }
    
    goToImage(index) {
      if (index === this.currentIndex || index >= this.items.length || index < 0) {
        return;
      }
      
      console.log('Switching to image:', index);
      
      const currentItem = this.items[this.currentIndex];
      const nextItem = this.items[index];
      
      this.updateIndicators(index);
      this.updateAriaAttributes(index);
      
      this.smoothTransition(currentItem, nextItem);
      this.currentIndex = index;
    }
    
    updateIndicators(newIndex) {
      this.indicators.forEach((indicator, index) => {
        const isActive = index === newIndex;
        indicator.classList.toggle('active', isActive);
        indicator.setAttribute('aria-selected', isActive.toString());
      });
    }
    
    updateAriaAttributes(newIndex) {
      this.items.forEach((item, index) => {
        item.setAttribute('aria-hidden', (index !== newIndex).toString());
      });
    }
    
    smoothTransition(currentItem, nextItem) {
      // Animate current item out
      currentItem.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
      currentItem.style.opacity = '0';
      currentItem.style.transform = 'scale(0.9)';
      
      // Prepare and animate next item in
      nextItem.style.opacity = '0';
      nextItem.style.transform = 'scale(1.1)';
      nextItem.style.transition = 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      
      setTimeout(() => {
        nextItem.classList.add('active');
        nextItem.style.opacity = '1';
        nextItem.style.transform = 'scale(1)';
        
        setTimeout(() => {
          currentItem.classList.remove('active');
          currentItem.style.transition = '';
          nextItem.style.transition = '';
        }, 500);
      }, 200);
    }
    
    nextImage() {
      if (this.items.length <= 1) return;
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.goToImage(nextIndex);
    }
    
    startAutoHover() {
      if (this.intervalId || this.items.length <= 1 || !this.isVisible || 
          this.isDestroyed || this.isHovering) {
        return;
      }
      
      console.log('Auto hover started');
      this.intervalId = setInterval(() => {
        if (!document.hidden && this.isVisible && !this.isDestroyed && !this.isHovering) {
          this.nextImage();
        }
      }, this.hoverInterval);
    }
    
    pauseAutoHover() {
      if (this.intervalId) {
        console.log('Auto hover paused');
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
    
    resumeAutoHover() {
      if (this.autoHover && !this.intervalId && this.items.length > 1 && 
          !document.hidden && this.isVisible && !this.isDestroyed && !this.isHovering) {
        console.log('Auto hover resumed');
        this.startAutoHover();
      }
    }
    
    destroy() {
      this.isDestroyed = true;
      this.pauseAutoHover();
      
      if (this.observer) {
        this.observer.disconnect();
      }
      
      if (this.visibilityHandler) {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
    }
  }
  
  // Initialize sections
  const splitSections = [];
  document.querySelectorAll('.split-section').forEach(element => {
    if (!element.dataset.initialized) {
      element.dataset.initialized = 'true';
      splitSections.push(new SplitSectionProduct(element));
    }
  });
  
  // Store instances globally for cleanup
  if (!window.splitSectionProducts) {
    window.splitSectionProducts = [];
  }
  window.splitSectionProducts.push(...splitSections);
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (window.splitSectionProducts) {
      window.splitSectionProducts.forEach(section => section.destroy());
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-floating-images"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class FloatingMediaShowcase {
    constructor(element) {
      this.element = element;
      this.wrapper = element.querySelector('.floating-media__wrapper');
      if (!this.wrapper) return;
      
      this.items = element.querySelectorAll('.floating-media__item');
      this.indicators = element.querySelectorAll('.floating-media__indicator');
      this.prevBtn = element.querySelector('[data-action="prev"]');
      this.nextBtn = element.querySelector('[data-action="next"]');
      
      this.currentIndex = 0;
      this.transitionTime = parseInt(this.wrapper.dataset.transitionTime) || 5000;
      this.autoRotate = this.wrapper.dataset.autoRotate === 'true';
      this.floatIntensity = parseInt(this.wrapper.dataset.floatIntensity) || 10;
      this.floatSpeed = parseInt(this.wrapper.dataset.floatSpeed) || 3;
      this.intervalId = null;
      this.isTransitioning = false;
      this.isVisible = true;
      
      this.init();
    }
    
    init() {
      this.setupItems();
      this.bindEvents();
      this.setupIntersectionObserver();
      
      if (this.autoRotate && this.items.length > 1) {
        this.startAutoRotation();
      }
    }
    
    setupItems() {
      this.items.forEach((item, index) => {
        if (index === 0) {
          item.classList.add('active');
          item.style.opacity = '1';
          item.style.transform = 'translateY(0) scale(1)';
          item.style.filter = 'blur(0)';
          item.setAttribute('aria-hidden', 'false');
        } else {
          item.classList.remove('active');
          item.style.opacity = '0';
          item.style.transform = 'translateY(20px) scale(0.98)';
          item.style.filter = 'blur(5px)';
          item.setAttribute('aria-hidden', 'true');
        }
      });
      
      this.element.style.setProperty('--float-intensity', `${this.floatIntensity}px`);
      this.element.style.setProperty('--float-speed', `${this.floatSpeed}s`);
    }
    
    setupIntersectionObserver() {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (!this.isVisible) {
              this.pauseAutoRotation();
            } else if (this.autoRotate) {
              this.resumeAutoRotation();
            }
          });
        }, { threshold: 0.1 });
        
        observer.observe(this.element);
      }
    }
    
    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.prevImage();
        });
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextImage();
        });
      }
      
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToImage(index);
        });
        
        indicator.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.goToImage(index);
          }
        });
      });
      
      this.element.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevImage();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextImage();
        }
      });
      
      if (this.autoRotate) {
        this.element.addEventListener('mouseenter', () => this.pauseAutoRotation());
        this.element.addEventListener('mouseleave', () => this.resumeAutoRotation());
        this.element.addEventListener('focusin', () => this.pauseAutoRotation());
        this.element.addEventListener('focusout', () => this.resumeAutoRotation());
        this.element.addEventListener('touchstart', () => this.pauseAutoRotation(), { passive: true });
        this.element.addEventListener('touchend', () => {
          setTimeout(() => this.resumeAutoRotation(), 2000);
        }, { passive: true });
        
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.pauseAutoRotation();
          } else if (this.isVisible) {
            this.resumeAutoRotation();
          }
        });
      }
    }
    
    goToImage(index) {
      if (this.isTransitioning || index === this.currentIndex || index >= this.items.length || index < 0) return;
      
      this.isTransitioning = true;
      const currentItem = this.items[this.currentIndex];
      const nextItem = this.items[index];
      
      this.updateIndicators(index);
      
      currentItem.setAttribute('aria-hidden', 'true');
      nextItem.setAttribute('aria-hidden', 'false');
      
      this.smoothTransition(currentItem, nextItem, () => {
        this.currentIndex = index;
        this.isTransitioning = false;
        this.announceImageChange(index);
      });
    }
    
    announceImageChange(index) {
      const announcement = `Image ${index + 1} of ${this.items.length}`;
      const announcer = document.createElement('div');
      announcer.setAttribute('aria-live', 'polite');
      announcer.setAttribute('aria-atomic', 'true');
      announcer.className = 'visually-hidden';
      announcer.textContent = announcement;
      
      document.body.appendChild(announcer);
      setTimeout(() => document.body.removeChild(announcer), 1000);
    }
    
    updateIndicators(newIndex) {
      this.indicators.forEach((indicator, index) => {
        if (index === this.currentIndex) {
          indicator.classList.remove('active');
          indicator.setAttribute('aria-selected', 'false');
        }
        if (index === newIndex) {
          indicator.classList.add('active');
          indicator.setAttribute('aria-selected', 'true');
        }
      });
    }
    
    smoothTransition(currentItem, nextItem, callback) {
      const direction = this.currentIndex < Array.from(this.items).indexOf(nextItem) ? 1 : -1;
      
      nextItem.style.opacity = '0';
      nextItem.style.transform = `translateY(${30 * direction}px) scale(0.95)`;
      nextItem.style.filter = 'blur(8px)';
      nextItem.style.transition = 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      
      currentItem.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      currentItem.style.opacity = '0';
      currentItem.style.transform = `translateY(${-20 * direction}px) scale(1.02)`;
      currentItem.style.filter = 'blur(8px)';
      
      setTimeout(() => {
        nextItem.classList.add('active');
        nextItem.style.opacity = '1';
        nextItem.style.transform = 'translateY(0) scale(1)';
        nextItem.style.filter = 'blur(0)';
        
        setTimeout(() => {
          currentItem.classList.remove('active');
          currentItem.style.transition = '';
          currentItem.style.transform = 'translateY(20px) scale(0.98)';
          currentItem.style.filter = 'blur(5px)';
          
          setTimeout(() => {
            nextItem.style.transition = '';
            callback();
          }, 100);
        }, 200);
      }, 300);
    }
    
    nextImage() {
      if (this.items.length <= 1) return;
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.goToImage(nextIndex);
    }
    
    prevImage() {
      if (this.items.length <= 1) return;
      const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.goToImage(prevIndex);
    }
    
    startAutoRotation() {
      if (this.intervalId || this.items.length <= 1 || !this.isVisible) return;
      
      this.intervalId = setInterval(() => {
        if (!this.isTransitioning && !document.hidden && this.isVisible) {
          this.nextImage();
        }
      }, this.transitionTime);
    }
    
    pauseAutoRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
    
    resumeAutoRotation() {
      if (this.autoRotate && !this.intervalId && this.items.length > 1 && !document.hidden && this.isVisible) {
        this.startAutoRotation();
      }
    }
    
    destroy() {
      this.pauseAutoRotation();
    }
  }
  
  const showcases = [];
  document.querySelectorAll('.floating-media-showcase').forEach(element => {
    showcases.push(new FloatingMediaShowcase(element));
  });
  
  window.addEventListener('beforeunload', () => {
    showcases.forEach(showcase => showcase.destroy());
  });
  
  window.floatingMediaShowcases = showcases;
});

  } catch(e) { console.error(e); }
})();
})();
